import { FeedbackState } from './useFeedbackState';

const sessionStorageName = 'cabmun_widget_feedback';

export const getFeedbackStorage = () => {
  const result = sessionStorage.getItem(sessionStorageName);
  if (result) return JSON.parse(result) as FeedbackState['values'];
  return null;
};

export const setFeedbackStorage = (values: FeedbackState['values']) => {
  const result = sessionStorage.setItem(sessionStorageName, JSON.stringify(values));
};
